import { library, dom } from "@fortawesome/fontawesome-svg-core";

import {
  faArrowCircleRight,
  faChartColumn,
  faCheckCircle,
  faCircleUser,
  faCog,
  faEdit,
  faEye,
  faEyeSlash,
  faFileArrowUp,
  faFilter,
  faGripLines,
  faLock,
  faMagnifyingGlass,
  faMinusCircle,
  faNewspaper,
  faPen,
  faPlus,
  faPlusCircle,
  faReceipt,
  faSliders,
  faSort,
  faTimes,
  faTimesCircle,
  faVolumeHigh,
  faVolumeXmark,
} from "@fortawesome/free-solid-svg-icons";

import {
  faBuildings,
  faGrid,
  faSlider,
  faGripDotsVertical,
  faCircleExclamation,
} from "@fortawesome/pro-solid-svg-icons";

library.add(
  faArrowCircleRight,
  faBuildings,
  faChartColumn,
  faCheckCircle,
  faCircleUser,
  faCog,
  faEdit,
  faEye,
  faEyeSlash,
  faFileArrowUp,
  faFilter,
  faGrid,
  faGripLines,
  faLock,
  faMagnifyingGlass,
  faMinusCircle,
  faNewspaper,
  faPen,
  faPlus,
  faPlusCircle,
  faReceipt,
  faSliders,
  faSlider,
  faSort,
  faTimes,
  faTimesCircle,
  faGripDotsVertical,
  faCircleExclamation,
  faVolumeHigh,
  faVolumeXmark
);

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.
dom.watch();
